import React, { useEffect, useCallback, useState} from 'react';
import {setArrangementPatternSelected} from 'actions/index.js';
import {setShowArrangementTracks} from 'actions/index.js';
import {connect} from 'react-redux';

const TracksShowButton = ({
    patternSelected,
    setPatternSelected,
    subSequence,
    show,
    setShowArrangementTracks
}) => { 
    const onClick = useCallback(() => {
        if (show && patternSelected && patternSelected.subSequence === subSequence) {
            // hiding so we must unselect any selected patterns
            setPatternSelected(undefined);
        }
        setShowArrangementTracks(!show);
    }, [patternSelected, show, subSequence]);
    return (
        <div
          onClick={onClick}
          className="tracks-show-button">
          {show ? <div className="arrow-down"/> : <div className="arrow-right"/>}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      show: state.arrangement.showTracks[props.subSequence.id],
      patternSelected: state.arrangement.patternSelected
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setShowArrangementTracks: (x) => dispatch(setShowArrangementTracks(props.subSequence.id, x)),
      setPatternSelected: (x) => dispatch(setArrangementPatternSelected(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TracksShowButton);
